"use strict";
exports.__esModule = true;
var PaymentMethodCode;
(function (PaymentMethodCode) {
    PaymentMethodCode["ROZLOZ_TO"] = "SPLIT_PAYMENT";
    PaymentMethodCode["ODLOZ_TO"] = "DEFERRED_PAYMENT";
})(PaymentMethodCode || (PaymentMethodCode = {}));
exports["default"] = PaymentMethodCode;
